import React from 'react'

const Coapplicant = ({row}) => {
    return (
        <div>{row?.coapplicant?.pan_name ? row?.coapplicant?.pan_name + (' (Co-applicant)') : "Applicant"}</div>
    )
}

export default Coapplicant